import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  adGroups: [],
  maxBiddingAmount: 300,
  previewMaxBiddingAmount: 300,
}

export const showAdGroupMaxBiddingAmountEdit = createAxiosThunk(
  'dashboard/showAdGroupMaxBiddingAmountEdit',
  adGroupIds => api.ad.getAdGroups(adGroupIds)
)

export const updateAdGroupMaxBiddingAmountEdit = createAxiosThunk(
  'dashboard/updateAdGroupMaxBiddingAmountEdit',
  (noArgs, { getState }) => {
    const { adGroups, previewMaxBiddingAmount } =
      getState().dashboard.operation.adGroupMaxBiddingAmountEdit
    return api.ad.patchAdGroupsBiddingStrategy({
      adGroupIds: adGroups.map(({ id }) => id),
      changeMaxBiddingAmount: 'Y',
      maxBiddingAmount: previewMaxBiddingAmount,
      changeContentMatchingMaxBiddingAmount: 'N',
      changePcWeight: 'N',
      changeMobileWeight: 'N',
      changeKeywordExtensionWeight: 'N',
    })
  }
)
const adGroupMaxBiddingAmountEditSlice = createSlice({
  name: 'dashboard/adGroupMaxBiddingAmountEdit',
  initialState,

  reducers: {
    hideAdGroupMaxBiddingAmountEdit: () => initialState,
    showPreview: (state, { payload }) => {
      state.previewMaxBiddingAmount = payload
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(showAdGroupMaxBiddingAmountEdit.pending, state => {
      state.isLoading = true
      state.visible = true
    })

    builder.addCase(
      showAdGroupMaxBiddingAmountEdit.rejected,
      (state, { payload }) => {
        state.loadingError = payload
        state.isLoading = false
      }
    )

    builder.addCase(
      showAdGroupMaxBiddingAmountEdit.fulfilled,
      (state, { payload: { adGroupDtos } }) => {
        const adGroups = adGroupDtos.map(({ id, name, biddingStrategy }) => ({
          id,
          name,
          biddingStrategy,
        }))
        state.adGroups = adGroups
        const hasSameValue =
          adGroups.length > 1 &&
          adGroups.every(
            (value, index, array) =>
              value?.biddingStrategy?.maxBiddingAmount ===
              array[0]?.biddingStrategy?.maxBiddingAmount
          )
        if (adGroups.length === 1 || hasSameValue) {
          const [first] = adGroups
          const {
            biddingStrategy: { maxBiddingAmount },
          } = first
          state.maxBiddingAmount = maxBiddingAmount
        }
        state.isLoading = false
      }
    )

    builder.addCase(updateAdGroupMaxBiddingAmountEdit.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateAdGroupMaxBiddingAmountEdit.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateAdGroupMaxBiddingAmountEdit.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const { hideAdGroupMaxBiddingAmountEdit, showPreview, hidePreview } =
  adGroupMaxBiddingAmountEditSlice.actions
export default adGroupMaxBiddingAmountEditSlice.reducer
